import { render, staticRenderFns } from "./bankcashaccuser.vue?vue&type=template&id=5e95f7c6"
import script from "./bankcashaccuser.vue?vue&type=script&lang=js"
export * from "./bankcashaccuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports